import { type ReactNode, useState } from 'react';
import { Unlink2 } from 'lucide-react';
import { useRelinkManychat } from '@/hooks/use-ig-mutations';

type Props = {
  memberId: string;
  hasManychatId: boolean;
  onCleared?: (() => void) | undefined;
};

const BTN =
  'inline-flex items-center gap-xs rounded-md border border-white/[0.06] px-sm py-1 text-[11px] text-text-secondary transition-colors hover:border-brand-red/40 hover:text-brand-red disabled:opacity-50';
const TITLE =
  'Borra el ManyChat ID. El bot se re-vincula al próximo lead del miembro.';

function useRelinkClick(memberId: string, onCleared?: () => void) {
  const relink = useRelinkManychat();
  const [confirming, setConfirming] = useState(false);
  const onClick = (): void => {
    if (!confirming) return setConfirming(true);
    relink.mutate(memberId, {
      onSuccess: () => {
        setConfirming(false);
        onCleared?.();
      },
      onError: () => setConfirming(false),
    });
  };
  return { onClick, confirming, pending: relink.isPending };
}

export function RelinkManychatButton(p: Props): ReactNode {
  const { onClick, confirming, pending } = useRelinkClick(
    p.memberId,
    p.onCleared
  );
  if (!p.hasManychatId) return null;
  return (
    <button onClick={onClick} disabled={pending} className={BTN} title={TITLE}>
      <Unlink2 size={12} />
      {confirming ? '¿Confirmar?' : 'Re-vincular ManyChat'}
    </button>
  );
}
